const testimonials = [
  {
    id: 'testimonial-1',
    name: 'Priya Mehta',
    role: 'Owner, Spice Garden',
    location: 'Mumbai, India',
    rating: 5,
    avatar: 'PM',
    avatarBg: '#7C3AED',
    text: "I used to spend 20 minutes agonising over a reply to a 2-star review. Now I generate one in seconds that actually sounds like me — warm, specific, and professional. My TripAdvisor response rate went from 30% to 94% in six weeks.",
  },
  {
    id: 'testimonial-2',
    name: 'Callum MacLeod',
    role: 'General Manager, The Harbour Arms',
    location: 'Edinburgh, Scotland',
    rating: 5,
    avatar: 'CM',
    avatarBg: '#0369A1',
    text: "The replies don't sound AI-generated at all — they reference specific things from the review and feel genuinely personal. One reviewer actually came back after seeing our response and left a 5-star update. Worth every penny.",
  },
  {
    id: 'testimonial-3',
    name: 'Lucia Ferreira',
    role: 'Co-owner, Cantinho do Sabor',
    location: 'Porto, Portugal',
    rating: 5,
    avatar: 'LF',
    avatarBg: '#C1440E',
    text: "Managing responses for three locations used to be a part-time job. ReviewReply handles it in minutes. The tone options are perfect — I use 'Apologetic' for complaints and 'Grateful' for the glowing ones, and the results are always spot-on.",
  },
];

export default function TestimonialsSection() {
  return (
    <section
      className="py-20 lg:py-28"
      style={{ backgroundColor: 'var(--secondary)' }}
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="section-label mb-3">What owners say</p>
          <h2 className="font-serif text-display-md mb-4" style={{ color: 'var(--foreground)' }}>
            Real results from real restaurants
          </h2>
          <p className="text-base leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
            Restaurant owners across 38 countries use ReviewReply AI every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials?.map((t) => (
            <div key={t?.id} className="card-elevated p-7 flex flex-col gap-5">
              {/* Stars */}
              <div className="flex gap-1">
                {Array.from({ length: t?.rating })?.map((_, i) => (
                  <svg
                    key={`${t?.id}-star-${i}`}
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="var(--accent)"
                  >
                    <path d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
                  </svg>
                ))}
              </div>

              {/* Quote */}
              <p className="text-sm leading-relaxed flex-1" style={{ color: 'var(--foreground)' }}>
                &ldquo;{t?.text}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-2 border-t" style={{ borderColor: 'var(--border)' }}>
                <div
                  className="w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
                  style={{ backgroundColor: t?.avatarBg, color: '#FDFAF6' }}
                >
                  {t?.avatar}
                </div>
                <div>
                  <p className="text-sm font-semibold" style={{ color: 'var(--foreground)' }}>
                    {t?.name}
                  </p>
                  <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
                    {t?.role} · {t?.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}